import React from 'react'

const Logo = () => {
  return (
    <img style={{ position: "relative", height: "100%", pointerEvents: "none", userSelect: "none" }} src="/svgs/anjumorilogo.svg" alt="anjumorilogo" />
  )
}

export default Logo